import React, {Component} from 'react';
import {
    Container
} from 'reactstrap'
import posed from 'react-pose'

import styles from './SearchHeader.css';

import SearchBar from '../SearchBar/SearchBar'
import Headline from "../Headline/Headline";

const AnimatedHeader = posed.div({
    minimized: {
        height: 'auto',
        paddingTop: '122px',
        paddingBottom: '0',
    },
    full: {
        height: '120vh',
        paddingBottom: '20vh'
    }
});

const ToggleElement = posed.div({
    enter: {opacit: 1},
    exit: {opacity: 0}
})

export default class SearchHeader extends Component {
    render() {
        const {fachgruppen, searchQuery, searchSubmit, minimized, iframe, iframeDocs} = this.props;

        let classes = [styles.wrapper];
        if(minimized !== undefined) {
            classes.push(styles.minimizedWrapper);
        }

        return (
            <AnimatedHeader pose={minimized ? 'minimized' : 'full'} className={classes.join(' ')}>

                    <Container className={styles.searchContainer}>

                        {!minimized && [
                            <ToggleElement>
                                <Headline large>Finden Sie kurzfristig, einfach und schnell<br/> Ihren nächsten
                                    Arzttermin.</Headline>
                            </ToggleElement>
                        ]}

                        <SearchBar
                            searchQuery={searchQuery}
                            fachgruppen={fachgruppen}
                            iframe={iframe ? iframe : false}
                            iframeDocs={iframeDocs}
                            handleSearchSubmit={searchSubmit}
                        />

                        {!minimized && [
                            <ToggleElement>
                                <div className={styles.showMore} onClick={() => {window.scrollTo({
                                    top: window.innerHeight - 100,
                                    behavior: 'smooth',
                                });}}>
                                    <span>Mehr erfahren</span>
                                </div>
                            </ToggleElement>
                        ]}
                    </Container>

            </AnimatedHeader>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SearchHeader/SearchHeader.js